import {DOCUMENT} from '@angular/common';
import {inject, isDevMode} from '@angular/core';
import {CanActivateFn} from '@angular/router';

import {ConfigService} from './config_service';

let isMapsScriptLoaded = false;

export const googleMapsLoaderGuard: CanActivateFn = () => {
  const window = inject(DOCUMENT).defaultView;
  const document = inject(DOCUMENT);
  const configService = inject(ConfigService);

  /* eslint-disable no-console */
  // If already loaded or running on the server, let the route proceed instantly
  if (isMapsScriptLoaded || !window) {
    return true;
  }
  try {
    const apiKey = configService.globalRuntimeConfig?.googleMaps?.apiKey;

    if (!apiKey) {
      if (isDevMode()) {
        console.warn(
          'Google Maps API key is undefined or missing. Map features may not load correctly.',
        );
      } else {
        console.error(
          'CRITICAL: Google Maps API key is undefined or missing in production config!',
        );
      }
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    const keyParam = apiKey ? `&key=${apiKey}` : '';
    script.src = `https://maps.googleapis.com/maps/api/js?v=weekly${keyParam}&libraries=geometry,places`;
    script.defer = true;
    script.async = true;

    script.onload = () => {
      isMapsScriptLoaded = true;
      console.log('Google Maps API injected successfully.');
    };

    document.head.appendChild(script);
  } catch (error) {
    console.error('Failed to inject maps script:', error);
  }
  return true;
};
